@switch (step_id.value) {
  @case (1) {
    <ng-container *ngTemplateOutlet="selectOrderForTemplate" />
  }
  @case (2) {
    <ng-container *ngTemplateOutlet="selectPersonTemplate" />
  }
  @case (3) {
    <ng-container *ngTemplateOutlet="selectActivityTemplate" />
  }
}

<!-- Step: 1 -->
<ng-template #selectOrderForTemplate>
  <ng-container *ngTemplateOutlet="header" />

  <div class="modal-body pt-0">
    <p>{{ 'who_are_you_ordering_for' | translate }}</p>

    <div class="row row-cols-1 row-cols-md-2 g-3">
      @for (item of order_for_options; track item) {
        <div class="col">
          <div
            as-button
            class="card text-center elevate-white"
            [attr.aria-label]="item.name"
            (click)="selectOrderFor(item.name)"
          >
            <div class="card-body d-flex justify-content-center">
              <div class="row flex-column">
                <div class="col">
                  <span class="material-icon-tangoe material-icons">{{ item.icon }}</span>
                </div>
                <div class="col">
                  <span class="fw-normal line-clamp">{{ item.name }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</ng-template>

<!-- Step: 2 -->
<ng-template #selectPersonTemplate>
  <ng-container *ngTemplateOutlet="header" />

  <div class="modal-body py-0">
    <p>{{ 'who_are_you_ordering_for' | translate }}</p>

    <form>
      <div class="form-group mb-3">
        <tds-type-ahead
          id="person-search"
          placeholder="{{ 'search_detailed_placeholder' | translate }}"
          [control]="person"
          [typeahead]="search"
          [loading]="loading"
          [item_not_found]="person_not_found"
          [result_template]="person.value ? resultTemplate : null"
          [result_format]="input_format"
          [input_format]="input_format"
          [input_required_translation]="
            'input_is_required' | translate: ('search_detailed_placeholder' | translate)
          "
          [no_results_found_translation]="'no_results_found' | translate"
          [loading_translation]="'loading' | translate"
          (onTypeaheadBlur)="onSearchBlur($event)"
          (selectItem)="onSelectPerson($event)"
        />
      </div>
    </form>
  </div>

  <div class="modal-footer border-top-0 pt-0">
    @if (!is_bulk_order || person.value) {
      <button
        class="btn btn-outline-secondary"
        type="button"
        (click)="
          goToStep(
            person.value ? select_person_template : select_order_for_template,
            person.value ? 2 : 1
          );
          clearPerson()
        "
      >
        {{ 'back' | translate }}
      </button>
    } @else {
      <button
        class="btn btn-outline-secondary"
        type="button"
        (click)="clearPerson(); resetTemplate()"
      >
        {{ 'cancel' | translate }}
      </button>
    }

    <ng-template #personSelectCancelBtn>
      <button
        class="btn btn-outline-secondary"
        type="button"
        (click)="clearPerson(); resetTemplate()"
      >
        {{ 'cancel' | translate }}
      </button>
    </ng-template>

    <button
      class="btn btn-primary"
      type="button"
      [disabled]="!person.value"
      (click)="goToStep(select_activity_template, 3)"
    >
      {{ 'continue' | translate }}
    </button>
  </div>
</ng-template>

<!-- Step: 3 -->
<ng-template #selectActivityTemplate>
  <ng-container *ngTemplateOutlet="header" />

  <div class="modal-body pt-0">
    @if (orderForOthers(true) || is_bulk_order) {
      <p class="fw-normal">
        {{ 'ordering_for_inputs' | translate: [person.value.person_name, person.value.email] }}
      </p>
    }

    @if (!isAuthorizedToPlaceOrder()) {
      <div class="row mb-3">
        <div class="col">
          <p i18n class="alert alert-info fw-normal mb-0" role="alert">
            {{ 'masquerade_alert' | translate }}
          </p>
        </div>
      </div>
    }

    <div class="row mb-3">
      <div class="col">
        <span id="ts-actiontype-listbox-description" class="fw-light">
          {{ 'select_an_option_below' | translate }}
        </span>
      </div>
    </div>

    <ts-listbox
      class="mb-3"
      aria-labelledby="ts-actiontype-listbox-label"
      aria-describedby="ts-actiontype-listbox-description"
      [options]="order_center_action && order_center_action.order_types"
      [tds-data-loader]="{
        key: 'enabled-activities',
        size: 'md'
      }"
      (selectionEvent)="selectAction($event)"
    >
      <ng-template #listboxOption let-orderType>
        {{ orderType.activity_display_name }}
      </ng-template>
    </ts-listbox>

    @if (no_activity_found) {
      <div class="alert alert-warning" role="alert">
        {{ 'no_options_available' | translate }}
      </div>
    }
  </div>

  @if (ofo_enabled || is_bulk_order) {
    <div class="modal-footer border-top-0 pt-0">
      <button
        class="btn btn-outline-secondary"
        type="button"
        (click)="
          goToStep(
            orderForOthers() || is_bulk_order ? select_person_template : select_order_for_template,
            orderForOthers() || is_bulk_order ? 2 : 1
          )
        "
      >
        {{ 'back' | translate }}
      </button>
    </div>
  }
</ng-template>

<!-- Header -->
<ng-template #header>
  <div class="modal-header">
    <h4 class="modal-title">{{ order_center_action.name }}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="resetTemplate()"></button>
  </div>
</ng-template>

<ng-template #resultTemplate>
  <ts-person-card [person]="person.value" (clear)="clearPerson()" />
</ng-template>
